import Vue from 'vue';
import Vuex from 'vuex';
import actions from './store/actionsApi';
import getters from './store/getters';
import mutations from './store/mutations';
import createPersistedState from 'vuex-persistedstate';
import initState from './store/initState';
import {analyticsMiddleware} from 'vue-analytics';
import SecureLS from "secure-ls";
import documentModule from "./store/modules/document";
const ls = new SecureLS({
  encodingType: "aes",
  isCompression: false,
  encryptionNamespace: "_ig",
  encryptionSecret: "!#$^%^@inGeTEr@kMaN@",
});

Vue.use(Vuex);
const isProd = process.env.NODE_ENV !== "development";
const storage = {
  getItem: (key) => ls.get(key),
  setItem: (key, value) => ls.set(key, value),
  removeItem: (key) => ls.remove(key),
};
const plugins = [
  createPersistedState({
    key: "ig-en",
    storage: isProd ? storage : null,
  }),analyticsMiddleware
];

export default new Vuex.Store({
  state: initState(),
  getters,
  mutations,
  actions,
  modules: {
    document: documentModule,
  },
  plugins,
});
